import { premiseDraftValidationSchema } from "src/components/Form/FormComponents/Validations";
import { GasOptionEnum } from "src/components/Form/types";
import { State } from "src/components/Premises/types";
import { IFormState } from "../types";

export const defaultFormState: IFormState = {
  state: "",
  connections: [],
  msaNumber: "",
  address: "",
  siteDetails: {
    id: "",
    street_name: "",
    street_type: "",
    suburb: "",
    state: State.VIC,
    postcode: "",
  },
  validationSchema: premiseDraftValidationSchema,
  requestingCompanies: [],
  postcode: "",
  electricityService: {
    isReadOnly: false,
  },
  isAccountReadOnly: false,
  gasServices: {
    [GasOptionEnum.BOTH]: {
      isReadOnly: false,
    },
    [GasOptionEnum.GAS_LINE]: {
      isReadOnly: false,
    },
    [GasOptionEnum.GAS_METER]: {
      isReadOnly: false,
    },
  },
};
